import { render, staticRenderFns } from "./muokkaa-paivittaista-merkintaa.vue?vue&type=template&id=58293f9a&scoped=true&"
import script from "./muokkaa-paivittaista-merkintaa.vue?vue&type=script&lang=ts&"
export * from "./muokkaa-paivittaista-merkintaa.vue?vue&type=script&lang=ts&"
import style0 from "./muokkaa-paivittaista-merkintaa.vue?vue&type=style&index=0&id=58293f9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58293f9a",
  null
  
)

export default component.exports